import { Grid } from "@mui/material";
import { Fragment, useEffect, useState } from "react";

import { useAxios } from "../../hooks";
import List from "./user list components/List";
import { PageHeader, Pagination } from "../../components";

export default function UsersList() {
  const axios = useAxios();

  const [loading, setLoading] = useState(false);
  const [usersList, setUserList] = useState([]);
  const [userStatus, setUserStatus] = useState("");
  const [page, setPage] = useState({
    page: 1,
    totalCount: 0,
    lastPage: false,
  });

  useEffect(() => {
    setLoading(true);
    axios({
      url: `/users/unverified/accounts?page=${page.page}&limit=10`,
    }).then((response) => {
      if (response.status) {
        setUserList(response.data.usersInfo);

        setPage((prev) => ({
          ...prev,
          totalCount: response.data.totalCount,
          lastPage: response.data.usersInfo.length < 10,
        }));
      }
      setLoading(false);
    });
  }, [axios, page.page]);

  useEffect(() => {
    if (userStatus) {
      axios({
        url: `/users/unverified/accounts?page=${page.page}&limit=10`,
      }).then((response) => {
        if (response.status) {
          setUserList(response.data.usersInfo);

          setPage((prev) => ({
            ...prev,
            totalCount: response.data.totalCount,
            lastPage: response.data.usersInfo.length < 10,
          }));
        }
      });
    }
  }, [userStatus, axios, page.page]);

  function handlePagination(step, index) {
    setPage((prev) => ({
      ...prev,
      page: step === "index" ? index : prev + (step === "next" ? 1 : -1),
    }));
  }
  return (
    <Fragment>
      <Grid container spacing={3}>
        <Grid size={12}>
          <PageHeader
            pageName={"New Account Request"}
            pageHeader="Account request list"
          />
        </Grid>
      </Grid>

      <List
        loading={loading}
        usersList={usersList}
        setUserStatus={setUserStatus}
      />

      {!!page.totalCount && (
        <Grid
          style={{ marginTop: "10px" }}
          item
          container
          display={"flex"}
          justifyContent={"center"}
        >
          <Pagination
            count={Math.ceil(page.totalCount / 10)}
            variant="outlined"
            color="secondary"
            page={page.page}
            onChange={(e, value) => handlePagination("index", value)}
          />
        </Grid>
      )}
    </Fragment>
  );
}
